<template>
    <div id="app">
        <main-header nowtab="play"></main-header>
        <main class="adjuster" v-if="competition">
            <div>
                <h2>{{ competition.name }}</h2>
                <p><a :href="competition.link" target="_blank">活动细则</a></p>
            </div>
            <div class="myteam">
                <div v-if="myteam">
                    <p>我的队伍: {{ myteam.name }}</p> 
                    <a-button type="danger">退出队伍</a-button>
                </div>
                <div v-else-if="hasLogin">
                    你还没有加入队伍
                    <a-button @click="createTeam">创建队伍</a-button>
                </div>
                <div v-else>
                    你尚未登录, 登录后才可进行比赛报名
                </div>
            </div>
            <div>
                <h3>队伍列表</h3>
                <a-table size="small" :pagination="false" :locale="{ emptyText:'还没有队伍' }"
                    :columns="columns" :data-source="teams" rowKey="id" :rowClassName="genRowClassName"
                >
                    <template slot="members" slot-scope="members">
                        <user-tag v-for="member of members" :key="member.user.id"
                            :user="member.user"
                        ></user-tag>
                    </template>
                    <template slot="opt" slot-scope="record">
                        <a-button v-if="record" size="small"></a-button>
                    </template>
                </a-table>
            </div>
        </main>
        <div v-else>
            不存在的比赛
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import { createFormData, getReason, getSSRdata } from '../../utils/utils'
import MainHeader from '@/components/MainHeader'
import Footer from '@/components/Footer'
import UserTag from '@/components/UserTag.vue'
import { prompt } from '../../utils/mixin'
import axios from 'axios'
import { mapState } from 'vuex'

export default {
    data: () => ({
        competition: null,
        myteam: null,
        teams: [],
        columns: [
            { title: '编号', dataIndex: 'id' },
            { title: '队伍名', dataIndex: 'name' },
            { title: '成员', dataIndex: 'members', scopedSlots: { customRender: 'members' } },
            { scopedSlots: { customRender: 'opt' } },
        ],
    }),
    computed: {
        ...mapState({ hasLogin: 'hasLogin' }),
    },
    created() {
        const { competition, myteam, teams } = getSSRdata("team");
        this.competition = competition;
        this.myteam = myteam;
        this.teams = teams;
    },
    methods: {
        prompt,
        async createTeam() {
            const teamName = await this.prompt("请输入队名");
            if (!teamName) {
                return;
            }
            try {
                const { data } = await axios
                    .post("/backend/competition/team/create.php", createFormData({
                        cid: this.competition.keyid, name: teamName,
                    }));
                if (data.code === 0) {
                    this.$message.success("创建成功");
                    window.location.reload();
                } else {
                    const reason = getReason(data.code);
                    this.$message.error(`创建失败: ${ reason }`);
                }
            } catch (e) {
                this.$message.error(`创建失败: ${ e }`);
            }
        },
        genRowClassName: function(record) {
            var classNames = [];
            if (this.myteam) {
                if (record.id == this.myteam.id) {
                    classNames.push("my-team-row");
                }
            }
            return classNames.join(" ");
        }
    },
    components: {
        MainHeader, Footer,
        UserTag,
    }
}
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.adjuster {
    margin: 20px auto;
    @media screen and (min-width: 1000px) {
        width: 1000px;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
    }
}
.myteam {
    text-align: left;
    margin: 5px;
}
</style>